
export default function Technology() {
  return (
    <section id="technology" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <div 
          className="w-full h-full"
          style={{
            backgroundImage: 'url(https://static.readdy.ai/image/04bffda83af79335128d062f8508dd8e/23b848263d280d43901c2dc5d1ccc3e9.jpeg)',
            backgroundRepeat: 'repeat',
            backgroundSize: 'auto'
          }}
        ></div>
        <div className="absolute inset-0" style={{ backgroundColor: 'rgba(19, 93, 169, 0.3)' }}></div>
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-6 lg:px-12 py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Image */}
          <div className="w-full h-[600px] overflow-hidden rounded-2xl">
            <img 
              src="https://static.readdy.ai/image/04bffda83af79335128d062f8508dd8e/56731301d5b0919579a98429c045591f.png" 
              alt="Hydrogen Technology" 
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Right Column - Content */}
          <div className="space-y-12">
            <div className="space-y-6">
              <h2 className="text-5xl lg:text-6xl font-bold text-white leading-tight">
                Our Technology
              </h2>
              <p className="text-lg text-white/90 leading-relaxed font-light text-justify">
                The technology operates using deionized water as the sole reactant, eliminating the need for chemical catalysts or supplemental additives. Its core functionality is based on a proprietary arrangement of dynamic electromagnetic fields coupled with a precisely regulated electrical current profile. This integrated system enhances molecular activation, optimizes ion transport dynamics, and significantly improves the energy conversion efficiency of the process.
              </p>
            </div>

            <div className="space-y-6">
              <h3 className="text-3xl lg:text-4xl font-bold" style={{ color: '#68c4ff' }}>
                Architecture
              </h3>
              <p className="text-lg text-white/90 leading-relaxed font-light text-justify">
                The architecture is engineered to prevent the formation of harmful byproducts, ensuring that hydrogen generation proceeds without secondary chemical residues or ecological liabilities.
              </p>
            </div>

            <div className="space-y-6">
              <h3 className="text-3xl lg:text-4xl font-bold" style={{ color: '#68c4ff' }}>
                Certified Results
              </h3>
              <p className="text-lg text-white/90 leading-relaxed font-light text-justify">
                The outstanding parameters of Hydville technology has been certified by highest experts confirming its ability and performance.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
